import React, {useState} from 'react'
import axios from 'axios'
import {useNavigate} from 'react-router-dom'

const API_URL = process.env.REACT_APP_API_URL
const VERIFY_URL = `${API_URL}/Custom/VerifyGraduateCard`

type GraduateCardResponse = {
  cardCode?: string | null
}

const GraduateCardVerificationPage: React.FC = () => {
  const [code, setCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const navigate = useNavigate()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const trimmedCode = code.trim()

    if (!trimmedCode) {
      setError('Lütfen mezun kartı doğrulama kodunu girin.')
      return
    }

    setLoading(true)
    setError(null)

    axios
      .post(VERIFY_URL, {
        code: trimmedCode,
      })
      .then((res) => {
        const data = res.data as GraduateCardResponse
        const targetCode =
          typeof data?.cardCode === 'string' && data.cardCode.trim().length > 0
            ? data.cardCode.trim()
            : trimmedCode

        navigate(`/gc/${encodeURIComponent(targetCode)}`)
      })
      .catch((err) => {
        const message =
          err?.response?.data && typeof err.response.data === 'string'
            ? err.response.data
            : 'Mezun kartı doğrulanamadı. Lütfen bilgilerinizi kontrol edin.'
        setError(message)
      })
      .finally(() => setLoading(false))
  }

  return (
    <div className='container py-10'>
      <div className='row justify-content-center'>
        <div className='col-12 col-md-8 col-lg-6'>
          <div className='card shadow-sm'>
            <div className='card-body p-10'>
              <h2 className='mb-6 text-center'>Mezun Kartı Doğrulama</h2>
              <p className='text-muted text-center mb-8'>
                Mezun kartını görüntülemek için doğrulama kodunu girin ve güvenlik adımını tamamlayın.
              </p>
              {error && (
                <div className='alert alert-danger' role='alert'>
                  {error}
                </div>
              )}
              <form onSubmit={handleSubmit} className='d-flex flex-column gap-5'>
                <div>
                  <label className='form-label required'>Doğrulama Kodu</label>
                  <input
                    type='text'
                    className='form-control form-control-lg'
                    value={code}
                    onChange={(event) => setCode(event.target.value)}
                    placeholder='Örnek: ABC123'
                    autoComplete='off'
                    disabled={loading}
                  />
                </div>
                <button type='submit' className='btn btn-primary btn-lg' disabled={loading}>
                  {loading ? 'Doğrulanıyor...' : 'Doğrula'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GraduateCardVerificationPage
